module.exports = __webpack_public_path__ + "img/robot (1).0950d67b.svg";